import React from 'react'
import muiThemeable from 'material-ui/styles/muiThemeable'

import { chatRoomRoute } from '../../app/routes'
import ChatRoomIframe from '../../addons/chat/ChatRoomIframe'

class PresentationChat extends React.Component {
  render() {
    const { appId, room, muiTheme } = this.props
    const {
      appBar: { height: appBarHeight },
      custom: { metrics: { tabNavigationHeight, basePadding } },
    } = muiTheme
    const topPosition = appBarHeight + tabNavigationHeight + 2 * basePadding
    return (
      <div
        style={{
          width: '100%',
          height: `calc(100vh - ${topPosition}px)`,
        }}
      >
        <ChatRoomIframe
          src={chatRoomRoute(appId, room.id)}
          title={`chat${room.id}`}
        />
      </div>
    )
  }
}

export default muiThemeable()(PresentationChat)



// WEBPACK FOOTER //
// ./src/containers/PresentationDetail/PresentationChat.js